<!-- <div class="theme-loader">
	<div class="spinner"></div>
</div> -->

<div class="theme-loader"><div id="spinner"><div></div>